import { configConstants } from "../constants/action.constants";
import { configService } from "../services/configs.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const configActions = {
  addConfig,
  getAllConfigs,
  getConfig,
  resetConfig,
  resetAddConfig
};

function getAllConfigs() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await configService.getAllConfigs();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CONFIGS
        )
      );
    }
  };

  function request() {
    return { type: configConstants.GET_CONFIGS_REQUEST };
  }
  function success(response) {
    return { type: configConstants.GET_CONFIGS_SUCCESS, response };
  }
  function failure(error) {
    return { type: configConstants.GET_CONFIGS_FAILURE, error };
  }
}

function getConfig(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await configService.getConfig(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_CONFIG}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: configConstants.VIEW_CONFIG_REQUEST, id };
  }
  function success(response) {
    return { type: configConstants.VIEW_CONFIG_SUCCESS, response };
  }
  function failure(error) {
    return { type: configConstants.VIEW_CONFIG_FAILURE, error };
  }
}

function addConfig(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await configService.addConfig(requestBody);
      response && dispatch(success(response));
      dispatch(getAllConfigs());
      if (requestBody.id) {
        history.push(routeConstants.CONFIGS.path);
      }
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_CONFIG : message.ADD_CONFIG
        )
      );
      dispatch(resetAddConfig());
      dispatch(resetConfig());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_CONFIG : message.ADD_CONFIG
        )
      );
    }
  };

  function request(requestBody) {
    return { type: configConstants.ADD_CONFIG_REQUEST, requestBody };
  }
  function success(response) {
    return { type: configConstants.ADD_CONFIG_SUCCESS, response };
  }
  function failure(error) {
    return { type: configConstants.ADD_CONFIG_FAILURE, error };
  }
}

function resetConfig() {
  return { type: configConstants.VIEW_CONFIG_RESET };
}

function resetAddConfig() {
  return { type: configConstants.ADD_CONFIG_RESET };
}
